import Vue from 'vue'
import {
  LANGUAGE,
  LOCAL_DEFAULT_CONFIG
} from '@/store/mutation-types'
import { loadLanguageAsync } from '@/locales'
import { noticeDingTalkGroupMessage } from '@/api/sso/dingTalk'

const state = {
  lang: 'zh_CN',
  isDemo: location.origin === location.protocol + process.env.VUE_APP_DEMO_URL,
  localDefaultConfig: {}
  // isDemo: true
}

const mutations = {
  SET_LANGUAGE: (state, lang) => {
    state.lang = lang
    Vue.ls.set(LANGUAGE, lang)
  }
}

const actions = {
  SetLang ($store, lang) {
    return new Promise((resolve, reject) => {
      $store.commit('SET_LANGUAGE', lang)
      loadLanguageAsync(lang)
        .then(() => {
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  SetLocalDefaultConfig ({ state }, config) {
    state.localDefaultConfig = {
      ...state.localDefaultConfig,
      ...config
    }
    Vue.ls.set(LOCAL_DEFAULT_CONFIG, state.localDefaultConfig)
  },
  DingTalkNotice ($store, params) {
    return noticeDingTalkGroupMessage(params)
  }
}

export default {
  state,
  mutations,
  actions
}
